import {
  Box,
  TableCell,
  TableRow,
  Typography,
  Button,
  useTheme,
  Tooltip,
  IconButton,
  Link,
} from '@mui/material'

import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { LinkIcon } from 'src/assets/icons'

import { useStyles } from './styles'
import { IUserWalletBase } from 'src/types'
import { getPolygonscanAddressUrl, shortenStringMiddle } from 'src/common/utils'
import { useCopy } from 'src/hooks'
import { useTranslation } from 'react-i18next'
import { HelperWrapper } from '../helper-wrapper'

interface IProps {
  handleMakeWalletActive: (address: string) => Promise<void>
  handleDisconectSelfManagedWallet: (address: string) => Promise<void>
  wallet: Omit<IUserWalletBase, 'privateKey'>
}

export const UserWalletsDetailsModalItem = ({
  wallet,
  handleMakeWalletActive,
  handleDisconectSelfManagedWallet,
}: IProps) => {
  const [t] = useTranslation()

  const classes = useStyles()
  const theme = useTheme()

  const handleCopy = useCopy(wallet.address)

  return (
    <TableRow>
      <TableCell width={'170px'}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '3px',
            justifyContent: 'space-between',
          }}
        >
          <Tooltip title={wallet.address}>
            <Typography sx={{ fontSize: '14px' }}>{shortenStringMiddle(wallet.address)}</Typography>
          </Tooltip>
          <Box sx={{ display: 'flex', gap: '3px' }}>
            <IconButton
              disabled={!wallet.address}
              size="small"
              component={Link}
              href={wallet.address ? getPolygonscanAddressUrl(wallet.address) : '#'}
              target="_blank"
            >
              <LinkIcon className={classes.copyIcon} />
            </IconButton>

            <IconButton size="small" disabled={!wallet.address} onClick={handleCopy}>
              <ContentCopyIcon className={classes.copyIcon} />
            </IconButton>
          </Box>
        </Box>
      </TableCell>
      <TableCell align="center">{wallet?.id ? wallet.scans : '-'}</TableCell>
      <TableCell align="center">{wallet?.id ? (wallet.trai_balance ?? 0) : '-'}</TableCell>
      <TableCell align="center">{wallet?.id ? (wallet.eth_balance ?? 0) : '-'}</TableCell>
      <TableCell>
        {wallet.is_custodial
          ? t('user-wallet-custodial-type-label.v')
          : t('user-wallet-self-managed-type-label.v')}
      </TableCell>
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
          {!wallet.active && (
            <Button
              size="small"
              variant="text"
              sx={{ textTransform: 'none' }}
              onClick={() => handleMakeWalletActive(wallet.address)}
            >
              <HelperWrapper t={'user-wallet-make-default-button-label'} />
            </Button>
          )}
          {!wallet.is_custodial && !wallet.active && (
            <Button
              size="small"
              variant="text"
              sx={{ textTransform: 'none', color: theme.palette.custom.warning2 }}
              onClick={() => handleDisconectSelfManagedWallet(wallet.address)}
            >
              <HelperWrapper t={'user-wallet-remove-self-managed-button-label'} />
            </Button>
          )}
        </Box>
      </TableCell>
    </TableRow>
  )
}
